import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';
import {
  InputMappingConstants,
  MAPPING_PATH_SUFFIX,
  MAPPING_SUFFIX,
} from 'components/property-editors/MappingConstants';
import { getChildValueAsString } from 'components/property-editors/utils/ProviderNodeUtils';

export const getMappingFieldPath = (child: ContextProviderNode, path: string[]) => [
  ...path,
  getMappingFieldName(child),
];

export const appendPath = (path: string[], suffix: string) => [...path, `${path[path.length - 1]}${suffix}`];

/** get pick path.... '__path' magic string is strange, but it's what legacy has */
export const getPickPath = (path: string[]) => appendPath(path, MAPPING_PATH_SUFFIX);

export const getMappingPath = (path: string[]) => appendPath(path, MAPPING_SUFFIX);

export const getBuildJoinArraysMappingValue = (mapping: string) => `${mapping}+add`;

export function getMappingField(child: ContextProviderNode) {
  return child.Children?.[0] ?? getLoadingNode(child.Node.Name);
}

export function getMappingFieldName(child: ContextProviderNode) {
  return getMappingField(child).Node.Name;
}

export function getMappingName(child: ContextProviderNode) {
  return getChildValueAsString(getMappingField(child));
}

export function getChildPath(path: string[], child: ContextProviderNode) {
  return child.Children[1] ? [...path, child.Children[1].Node.Name] : [...path];
}

export function isBuildJoinArrayMapping(mapping: string) {
  return mapping === InputMappingConstants.MAPPING_ARRAY || mapping === InputMappingConstants.MAPPING_ARRAY_CONCAT;
}

/**
 * Because ContextProviderNodeChangedNotification of type "Add" will come in sequence for
 * these in some circumstances (like Build Array), the outer part needs to be able to
 * render without error before the inner part is added. Thus we need a minimal "node" to render
 * between.
 * @param name of mapping node to show
 */
function getLoadingNode(name: string) {
  return {
    EditorConfigurationValues: [
      {
        Name: 'values',
        OutputValue: ['Unknown'],
      },
    ],
    Node: {
      __type: 'ContextPropertyNode:#DecisionsFramework.Design.Properties',
      Name: `${name}__mapping`,
      DisplayLabel: 'Mapping Type',
      DisplayLabelPosition: 3,
      Height: -1,
      MvcEditorName: 'MappingTypeSelector',
    },
  };
}
